import { render, staticRenderFns } from "./panel-main-equipment.vue?vue&type=template&id=d81b8d4c&scoped=true"
import script from "./panel-main-equipment.vue?vue&type=script&lang=js"
export * from "./panel-main-equipment.vue?vue&type=script&lang=js"
import style0 from "./panel-main-equipment.vue?vue&type=style&index=0&id=d81b8d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81b8d4c",
  null
  
)

export default component.exports